import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";

const PHONE = "393462179997"; // +39 346 2179997

export default function WhatsAppButton() {
  const { t } = useLang();
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(t.whatsapp.msg)}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label={t.whatsapp.label}
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.4, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.94 }}
      className="group fixed bottom-6 right-6 z-[60] flex items-center gap-3"
    >
      {/* Tooltip label */}
      <span className="hidden sm:block max-w-0 overflow-hidden whitespace-nowrap opacity-0 group-hover:max-w-[220px] group-hover:opacity-100 transition-all duration-500 bg-[#121212] border border-white/10 text-white text-sm font-body px-4 py-2 rounded-full">
        {t.whatsapp.label}
      </span>

      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-[0_8px_30px_rgba(37,211,102,0.35)]">
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
        <svg viewBox="0 0 32 32" className="relative h-7 w-7 fill-black" aria-hidden="true">
          <path d="M16.001 3.2C9.075 3.2 3.46 8.815 3.46 15.74c0 2.223.583 4.394 1.69 6.31L3.2 28.8l6.93-1.817a12.49 12.49 0 0 0 5.87 1.472h.005c6.925 0 12.54-5.615 12.54-12.54 0-3.352-1.305-6.503-3.676-8.874A12.46 12.46 0 0 0 16.001 3.2zm0 22.86h-.004a10.38 10.38 0 0 1-5.29-1.448l-.38-.225-3.912 1.026 1.044-3.814-.247-.391a10.34 10.34 0 0 1-1.585-5.518c0-5.757 4.686-10.443 10.447-10.443a10.38 10.38 0 0 1 7.384 3.063 10.37 10.37 0 0 1 3.058 7.388c0 5.757-4.686 10.443-10.443 10.443zm5.727-7.82c-.314-.157-1.857-.916-2.145-1.021-.288-.105-.497-.157-.706.157-.209.314-.81 1.021-.993 1.23-.183.209-.366.235-.68.078-.314-.157-1.326-.489-2.526-1.559-.933-.832-1.563-1.86-1.746-2.174-.183-.314-.02-.484.138-.64.141-.14.314-.366.471-.549.157-.183.209-.314.314-.523.105-.209.052-.392-.026-.549-.078-.157-.706-1.702-.967-2.331-.255-.611-.514-.528-.706-.538l-.601-.01c-.209 0-.549.078-.837.392-.288.314-1.098 1.073-1.098 2.618 0 1.545 1.124 3.037 1.281 3.246.157.209 2.212 3.377 5.36 4.736.749.323 1.333.516 1.788.66.751.239 1.435.205 1.976.124.603-.09 1.857-.759 2.119-1.492.262-.733.262-1.361.183-1.492-.078-.131-.288-.209-.601-.366z"/>
        </svg>
      </span>
    </motion.a>
  );
}
